import { AutogenLayoutZoneSuperRegion } from "./autogen/AutogenLayoutZoneSuperRegion";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

export class ZoneSuperRegion extends AutogenLayoutZoneSuperRegion {

    override onLoad(): void | Promise<void> {
        this.validateZoneSuperRegionRecordExist();
    }

    private validateZoneSuperRegionRecordExist() {
        const zoneSuperRegionUrl = "lme/dispatch/ZoneSuperRegion?mode=update&key=";
        const validateProps: DuplicateIdProps = { tableName: "zonesuperregion", screenName: "ZoneSuperRegion", navigateToUrl: zoneSuperRegionUrl };
        DuplicateId.configureIdTextbox(this.textboxId, validateProps);
    }

}
